/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_In_ProgressInputs */

const en_subtitle_export_in_progress = /** @type {(inputs: Subtitle_Export_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export in progress... please wait.`)
};

const fr_subtitle_export_in_progress = /** @type {(inputs: Subtitle_Export_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation en cours... veuillez patienter.`)
};

const de_subtitle_export_in_progress = /** @type {(inputs: Subtitle_Export_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export läuft... bitte warten.`)
};

const it_subtitle_export_in_progress = /** @type {(inputs: Subtitle_Export_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione in corso... attendere prego.`)
};

const ru_subtitle_export_in_progress = /** @type {(inputs: Subtitle_Export_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выполняется экспорт... пожалуйста, подождите.`)
};

const es_subtitle_export_in_progress = /** @type {(inputs: Subtitle_Export_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación en progreso... por favor espere.`)
};

const zh_cn2_subtitle_export_in_progress = /** @type {(inputs: Subtitle_Export_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出正在进行中……请稍候。`)
};

const ja_subtitle_export_in_progress = /** @type {(inputs: Subtitle_Export_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポート中です...お待ちください。`)
};

const hi_subtitle_export_in_progress = /** @type {(inputs: Subtitle_Export_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात प्रक्रिया जारी है... कृपया प्रतीक्षा करें।`)
};

const pt_pt2_subtitle_export_in_progress = /** @type {(inputs: Subtitle_Export_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação em andamento... aguarde.`)
};

/**
* | output |
* | --- |
* | "Export in progress... please wait." |
*
* @param {Subtitle_Export_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_in_progress = /** @type {((inputs?: Subtitle_Export_In_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_In_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_in_progress(inputs)
	if (locale === "de") return de_subtitle_export_in_progress(inputs)
	if (locale === "it") return it_subtitle_export_in_progress(inputs)
	if (locale === "ru") return ru_subtitle_export_in_progress(inputs)
	if (locale === "es") return es_subtitle_export_in_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_in_progress(inputs)
	if (locale === "ja") return ja_subtitle_export_in_progress(inputs)
	if (locale === "hi") return hi_subtitle_export_in_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_in_progress(inputs)
	return en_subtitle_export_in_progress(inputs)
});